angular.module('unica_media.media_services')

.factory('MediaListService', function ($http, getBaseApiURL) {

	var mediaListService = {};

	mediaListService.list = function (eventId, directoryId, limit, offset) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media/list/' + eventId + '/' + directoryId,
			data: {
				limit: limit,
				offset: offset,
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.medias;
			}

		});

	};


	mediaListService.get = function (mediaId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media/detail/' + mediaId,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.media;
			}

		});
	};


	mediaListService.download = function (mediaId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media/download/' + mediaId,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.media;
			}

		});
	};


	return mediaListService;
});